/**
 * Viewport Height Fix for iOS Safari
 * 
 * This script fixes the issue where iOS Safari's dynamic viewport height
 * (when address bar shows/hides) causes gaps at the bottom of full-height elements.
 * 
 * It sets a CSS custom property --vh that represents 1% of the actual viewport height,
 * which can be used in CSS as: height: calc(var(--vh, 1vh) * 100)
 */

(function() {
  'use strict';

  function setViewportHeight() {
    // Get the actual viewport height
    const vh = window.innerHeight * 0.01;
    
    // Set the CSS custom property
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  // Set initial value
  setViewportHeight();

  // Update on resize (handles orientation changes and address bar show/hide)
  window.addEventListener('resize', setViewportHeight);
  
  // Update on orientation change (additional safety for iOS)
  window.addEventListener('orientationchange', function() {
    // Small delay to ensure the viewport has updated
    setTimeout(setViewportHeight, 100);
  });

  // Update when the page becomes visible (handles tab switching)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      setViewportHeight();
    }
  });

})();
